<template>
  <SelectMultipleInput
    v-model="model"
    :items="items"
    item-text="inspTimingDtlName"
    item-value="inspTimingDtlCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'InspTimingDtlMultipleInput',

  mixins: [APIUtils, Message],

  components: { SelectMultipleInput },

  props: {
    value: {
      type: Array,
      default: () => [],
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0437')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    companyCatCd: {
      type: String,
      required: false,
      default: '',
    },
    inspTimingCd: {
      type: String,
      required: false,
      default: '',
    },
    inspClassCd: {
      type: String,
      required: false,
      default: '',
    },
    inspCat2Cd: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      const params = {
        companyCatCd: this.companyCatCd,
        inspTimingCd: this.inspTimingCd,
        inspClassCd: this.inspClassCd,
        inspCat2Cd: this.inspCat2Cd,
        validOnly: this.validOnly,
      }
      this.items = await API.get('/master/inspTimingDtls', params)
    } catch (error) {
      this.items = []
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0437') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
